import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SmartContract = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default SmartContract